import React from "react";
import { PublicNav } from "@/components/PublicNav";
import { Footer } from "@/components/Footer";
import { useT } from "@/i18n";
import { LEGAL } from "@/legal/it";

const FILL_RE = /(\[DA COMPILARE:[^\]]+\])/g;

const Highlight = ({ text }) => (
  <>
    {text.split(FILL_RE).map((part, i) =>
      FILL_RE.test(part) ? (
        <mark key={i} className="rounded bg-amber-200/70 px-1 py-0.5 font-medium text-amber-900 dark:bg-amber-500/25 dark:text-amber-200" data-testid="legal-fill-field">{part}</mark>
      ) : part
    )}
  </>
);

export function Legal({ kind }) {
  const { t } = useT();
  const doc = LEGAL[kind];
  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-testid="legal-title">{t(`legal.${kind}`)}</h1>
        <p className="mt-6 text-base leading-relaxed text-muted-foreground" data-testid="legal-intro"><Highlight text={doc.intro} /></p>
        <div className="mt-10 space-y-8">
          {doc.sections.map((s) => (
            <section key={s.h} data-testid="legal-section">
              <h2 className="font-display text-lg font-semibold text-foreground">{s.h}</h2>
              <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                {s.p.map((para, i) => <p key={i}><Highlight text={para} /></p>)}
              </div>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
